import React from 'react';
import Background from "../../assets/images/background/banner.jpg";
import "./about.css";
import { Link } from 'react-router-dom';
//image
import bg from "../../assets/images/About/bg-content.png";

export default function About() {
    return (
        <div>
            
            <section
                className="page-title"
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className="auto-container">
                    <h2>About Us</h2>
                    <ul className="bread-crumb clearfix">
                        <li>
                            <Link to="/">Home</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>Company</li>

                         <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>About Us</li>
                    </ul>
                </div>
            </section>

            <section
                className="about-one style-two about-section"
                style={{ backgroundImage: `url(${bg})`}}
            >
                <div className="container">
                    <h2 className="section-title">About Horizon WebInfo Pvt. Ltd.</h2>
                    <p>
                        Welcome to Horizon Webinfo Pvt. Ltd. known as <strong>HWPL,</strong> your trusted partner in the ever-evolving landscape of Information Technology. Established in 2005, we have been at the forefront of delivering cutting-edge IT solutions that empower businesses to thrive in the digital age.
                    </p>

                    <h2 className="section-title">Our Journey</h2>
                    <p>
                       Horizon Webinfo was born out of a vision to provide innovative and reliable IT services that cater to the unique needs of our diverse clientele. Over the years, our journey has been marked by a commitment to excellence, a passion for technology, and a relentless pursuit of customer satisfaction.
                    </p>

                    <h2 className="section-title">Helping Indian Businesses Grow with Smart Digital Solutions</h2>
                    <p>
                       At Horizon Webinfo, we work closely with startups, SMEs, and large enterprises to build technology solutions that actually solve business problems. Whether you want to automate operations, manage sales and accounts, track employees, or go online, our expert team ensures smooth execution and long-term support.
                    </p>
                </div>
            </section>

        </div>
    );
}
